import { useQuery } from '@tanstack/react-query';
import type { IGetConfigResponse } from '@treneo/models';

import { configApi } from './api';
import { APP_CONFIG_QUERY_KEY } from './config-query-keys';

export { APP_CONFIG_QUERY_KEY } from './config-query-keys';

const DEFAULT_APP_CONFIG: IGetConfigResponse = {
  sentrySettings: {},
  googleSettings: { clientId: '' },
  formsDefaultValuesSettings: {}
};

const getAppConfigQueryFn = async (): Promise<IGetConfigResponse> => {
  const result = await configApi.getConfig();
  if (result.isSuccess && result.data) {
    return result.data;
  }
  return DEFAULT_APP_CONFIG;
};

const APP_CONFIG_QUERY_OPTIONS = {
  queryKey: APP_CONFIG_QUERY_KEY,
  queryFn: getAppConfigQueryFn,
  staleTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchOnMount: false
} as const;

export const getAppConfigQueryOptions = () => APP_CONFIG_QUERY_OPTIONS;

export const useAppConfigQuery = () => useQuery(APP_CONFIG_QUERY_OPTIONS);
